module.exports = __webpack_public_path__ + "static/media/logo-internal.9664cac3.png";